<template>
    <div class="menu-form-container">
        <!-- Background Shapes -->
        <div class="background-shapes">
            <div class="shape triangle-1"></div>
            <div class="shape triangle-2"></div>
            <div class="shape circle"></div>
        </div>

        <!-- Menu Form -->
        <div class="menu-form">
            <h2 class="form-title">Add Menu Items</h2>
            <form @submit.prevent="addMenuItem">
                <row>
                    <div class="form-group">
                        <label for="itemName">Item Name</label>
                        <input
                                type="text"
                                id="itemName"
                                v-model="newItem.name"
                                placeholder="Enter item name"
                                required
                        />
                    </div>
                    <div class="form-group">
                        <label for="itemPrice">Order No</label>
                        <input
                                type="number"
                                id="itemPrice"
                                v-model="newItem.price"
                                placeholder="Enter item price"
                                required
                        />
                    </div>
                    <button type="submit" class="add-button">Add Item</button>
                </row>
            </form>

            <!-- Display Menu Items -->
            <div class="menu-items">
                <div v-for="(item, index) in menuItems" :key="index" class="menu-item">
                    <span class="item-name">{{ item.name }}</span>
                    <span class="item-price">${{ item.price }}</span>
                    <button @click="removeMenuItem(index)" class="remove-button">×</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                newItem: {
                    name: "",
                    price: null,
                },
                menuItems: [],
            };
        },
        methods: {
            addMenuItem() {
                if (this.newItem.name && this.newItem.price) {
                    this.menuItems.push({ ...this.newItem });
                    this.newItem.name = "";
                    this.newItem.price = null;
                }
            },
            removeMenuItem(index) {
                this.menuItems.splice(index, 1);
            },
        },
    };
</script>

<style scoped>
    .menu-form-container {
        position: relative;
        padding: 2rem;
        background: linear-gradient(135deg, #f5f7fa, #c3cfe2);
        border-radius: 15px;
        overflow: hidden;
    }

    .background-shapes {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
    }

    .shape {
        position: absolute;
        background: rgba(255, 255, 255, 0.3);
    }

    .triangle-1 {
        width: 0;
        height: 0;
        border-left: 100px solid transparent;
        border-right: 100px solid transparent;
        border-bottom: 200px solid rgba(255, 99, 71, 0.3);
        top: -50px;
        left: -50px;
        transform: rotate(45deg);
    }

    .triangle-2 {
        width: 0;
        height: 0;
        border-left: 80px solid transparent;
        border-right: 80px solid transparent;
        border-bottom: 160px solid rgba(70, 130, 180, 0.3);
        bottom: -80px;
        right: -80px;
        transform: rotate(-30deg);
    }

    .circle {
        width: 150px;
        height: 150px;
        border-radius: 50%;
        background: rgba(144, 238, 144, 0.3);
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .menu-form {
        position: relative;
        z-index: 2;
        /*background: rgba(255, 255, 255, 0.9);*/
        padding: 2rem;
        border-radius: 10px;
        /*box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);*/
        animation: fadeIn 0.5s ease-in-out;
    }

    .form-title {
        text-align: center;
        margin-bottom: 1.5rem;
        font-size: 1.8rem;
        color: #333;
    }

    .form-group {
        margin-bottom: 1rem;
    }

    .form-group label {
        display: block;
        margin-bottom: 0.5rem;
        font-weight: bold;
        color: #555;
    }

    .form-group input {
        width: 100%;
        padding: 0.75rem;
        border: 1px solid #ddd;
        border-radius: 5px;
        font-size: 1rem;
        transition: border-color 0.3s ease;
    }

    .form-group input:focus {
        border-color: #007bff;
        outline: none;
    }

    .add-button {
        width: 100%;
        padding: 0.75rem;
        background: #077747;
        color: white;
        border: none;
        border-radius: 5px;
        font-size: 1rem;
        cursor: pointer;
        transition: background 0.3s ease;
    }

    .add-button:hover {
        background: #0056b3;
    }

    .menu-items {
        margin-top: 1.5rem;
    }

    .menu-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.75rem;
        background: #f9f9f9;
        border: 1px solid #ddd;
        border-radius: 5px;
        margin-bottom: 0.5rem;
        animation: slideIn 0.3s ease-in-out;
    }

    .item-name {
        font-weight: bold;
        color: #333;
    }

    .item-price {
        color: #007bff;
    }

    .remove-button {
        background: #ff4d4d;
        color: white;
        border: none;
        border-radius: 50%;
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: background 0.3s ease;
    }

    .remove-button:hover {
        background: #cc0000;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(-20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes slideIn {
        from {
            opacity: 0;
            transform: translateX(-20px);
        }
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }
</style>